import { KeyValueModel } from "../../model";

export const SimNaoBooleanMock = [
    new KeyValueModel(true, 'Sim'),
    new KeyValueModel(false, 'Não'
    ),
];
